// library imports
import { TinyArea } from "@ant-design/plots";
// style imports
import "../../styles/Dashboard/StatisticGraphContent.css";
export default function _StatisticGraphContent({
  data,
  value,
  title,
  fillColor,
  fillColorGradient,
}) {
  const config = {
    width: "auto",
    autoFit: true,
    padding: 0,
    data,
    smooth: true,
    areaStyle: {
      fill: `l(270) 0:${fillColor} 0.5:${fillColor} 1:${fillColorGradient}`,
    },
    line: {
      color: fillColor,
    },
    tooltip: false,
  };

  return (
    <div className="statistic-graph-content">
      <div className="statistic-graph-detail">
        <span className="statistic-graph-title">{title}</span>
        <span className="statistic-graph-value">{value}</span>
      </div>

      <div className="statistic-graph-chart">
        <TinyArea {...config} />
      </div>
    </div>
  );
}
